import { FaCookie } from "react-icons/fa";
import { FaExpandAlt } from "react-icons/fa";
import { FaPenAlt } from "react-icons/fa";
import { FaRegArrowAltCircleDown } from "react-icons/fa";
import { Link } from "react-router-dom";

export default function Navbar() {
  return (
    <div className="nav">
      <div className="nav-tag">
        <FaCookie className="icon" />
        <a href="https://www.instagram.com/wonderbar.studio/" target="_blank">
          <h3>Playground</h3>
        </a>
      </div>
      <div className="nav-tag">
        <FaExpandAlt className="icon" />
        <h3>
          <Link to="/about" relative="/about">
            About
          </Link>
        </h3>
      </div>
      <div className="nav-tag">
        <FaPenAlt className="icon" />
        <a href="https://dev.to/ivavay" target="_blank">
          <h3>Blog</h3>
        </a>
      </div>
      <div className="nav-tag">
        <FaRegArrowAltCircleDown className="icon" />
        <a
          href="https://drive.google.com/file/d/1QwY8ejUtbD9vsraDX9XwAE8eOES3PH6u/view?usp=sharing"
          target="_blank"
        >
          <h3>Resume</h3>
        </a>
      </div>
    </div>
  );
}
